const React = require('react');
const classnames = require('classnames');
const ErrorBoundary = require('./error-boundary');
const NoImage = require('./svgs-v2/icons/no-image.svg').default;
const FaIcon = require('./fa-icon');
const v2Icons = require('./svgs-v2');

/**
 * @deprecated use FontAwesomeIcon from the @fortawesome/react-fontawesome package directly
 * @param {object} props
 * @param {string} name
 * @param {string} className
 * @param {string} viewBox
 * @param {'custom'|'fa'} type
 * @param {string} title
 * @returns {JSX.Element}
 */
function Icon({ name = '', className = '', viewBox = '', type = 'custom', title = '' }) {
  const svgProps = {
    className: classnames('icon', className),
    title,
  };
  if (viewBox) {
    svgProps.viewBox = viewBox;
  }

  if (type === 'fa') {
    // for backwards compatibility, prefer direct use of <FaIcon>
    return (
      <ErrorBoundary mode='icon' svgProps={svgProps}>
        <FaIcon name={name} {...svgProps} />
      </ErrorBoundary>
    );
  }

  try {
    const ReactComponent = v2Icons.default[name];
    return (
      <ErrorBoundary svgProps={svgProps}>
        <ReactComponent {...svgProps} />
      </ErrorBoundary>
    );
  } catch (error) {
    console.error(error);
    return <NoImage {...svgProps} />;
  }
}

/**
 * @deprecated use FontAwesomeIcon from the @fortawesome/react-fontawesome package directly
 */
const memoIcon = React.memo(Icon);
module.exports = memoIcon;
